import LegalPageLayout from "./LegalPageLayout";

export default function TermsOfService() {
  return (
    <LegalPageLayout title="Terms of Service" lastUpdated="2026-04-21">
      <p>
        The rules for using howisthe.surf. By using the site or creating an account, you
        agree to these terms.
      </p>

      <h2>1. Who can use it</h2>
      <p>
        You need to be at least 13 years old (16 if you're in the EU). Don't create an
        account or post reports on behalf of anyone else. If we find fake or automated
        accounts, we'll remove them.
      </p>

      <h2>2. Your account</h2>
      <p>
        You're responsible for what happens under your account. Don't share your password.
        If you suspect someone else has access, change the password and let us know.
      </p>

      <h2>3. Acceptable use</h2>
      <p>Don't use howisthe.surf to:</p>
      <ul>
        <li>Post false surf reports, spam, or promotional content.</li>
        <li>Harass, threaten, or impersonate anyone.</li>
        <li>
          Upload content that's illegal, infringes someone else's rights, or contains
          malware.
        </li>
        <li>
          Scrape the site, hit our APIs in ways that disrupt service, or try to bypass our
          security.
        </li>
        <li>Interfere with other users' ability to use the site.</li>
      </ul>
      <p>We can remove content or suspend accounts that violate these.</p>

      <h2>4. Your content</h2>
      <p>
        You keep ownership of the reports, photos, videos, comments, and everything else
        you post. By posting, you grant howisthe.surf a worldwide, non-exclusive,
        royalty-free license to display, distribute, and modify your content for the
        purpose of running and promoting the service. This license ends when you delete
        the content, except where we've already shared it with others (e.g. through embed
        or social preview).
      </p>
      <p>
        You confirm that you have the rights to everything you post, including any photos
        or videos of other people.
      </p>

      <h2>5. Surf forecasts are informational, not navigation</h2>
      <p>
        <strong>
          The forecasts, reports, camera feeds, and any other surf data on this site are
          for informational purposes only. They are not a substitute for real-world
          observation, local knowledge, or official marine forecasts.
        </strong>
      </p>
      <p>
        Surfing is dangerous. Conditions change fast. Always check local weather, tides,
        and advisories before entering the water. Know your ability, know the break, and
        don't paddle out if anything feels off.{" "}
        <strong>
          You are solely responsible for decisions you make based on information from this
          site.
        </strong>
      </p>

      <h2>6. Intellectual property</h2>
      <p>
        The site's design, code, brand, and anything we create — apart from user content —
        belong to us. You can share links to pages, screenshot for personal use, and embed
        public content where the site offers an embed mechanism. You can't rebrand,
        redistribute, or commercially exploit the site as a whole without written
        permission.
      </p>

      <h2>7. Third-party data</h2>
      <p>
        We show forecast data sourced from Open-Meteo, NOAA NDBC, NWS, and others, plus
        camera feeds operated by third parties. We don't control what they publish and
        can't guarantee accuracy, availability, or uptime of any external feed.
      </p>

      <h2>8. Termination</h2>
      <p>
        You can stop using the site anytime and delete your account via the profile menu
        or by emailing us. We can suspend or delete accounts that violate these terms,
        pose a risk to other users, or require us to in order to comply with the law.
        We'll give you a heads-up where reasonable.
      </p>

      <h2>9. Disclaimer</h2>
      <p>
        The site is provided "as is" and "as available". We don't guarantee it will be
        uninterrupted, error-free, secure, or meet your specific needs. We disclaim all
        warranties to the maximum extent allowed by law.
      </p>

      <h2>10. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, howisthe.surf and its operators are not
        liable for indirect, incidental, consequential, or punitive damages arising from
        your use of the site — including anything that happens to you or your property in
        the water. Our total liability for any claim is limited to the greater of (a) the
        amount you've paid us in the 12 months before the claim (typically zero, since the
        site is free), or (b) US$100.
      </p>

      <h2>11. Changes to these terms</h2>
      <p>
        We'll update this page when things change. If the change is material, we'll notify
        users with accounts by email or a banner. Continued use after a change means you
        accept the new terms.
      </p>

      <h2>12. Governing law</h2>
      <p>
        These terms are governed by the laws of the United States and the state in which
        the operator of howisthe.surf is based at the time of the dispute. Disputes should
        be resolved in the courts of that jurisdiction, except where mandatory
        consumer-protection law where you live provides otherwise.
      </p>

      <h2>13. Contact</h2>
      <p>
        <a href="mailto:hello@howisthe.surf">hello@howisthe.surf</a>.
      </p>
    </LegalPageLayout>
  );
}
